import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">

        <div className="footer-left">
          <p className="footer-name">Elizabeth Harrington</p>
          <p className="footer-tagline">Building digital products people actually use.</p>
          <p className="footer-copy">© {new Date().getFullYear()} Designed &amp; built with React</p>
        </div>

        <div className="footer-right">
          <div className="footer-col">
            <p className="footer-col-label">Navigation</p>
            <Link to="/">Home</Link>
            <Link to="/projects">Projects</Link>
            <Link to="/contact">About</Link>
          </div>
          <div className="footer-col">
            <p className="footer-col-label">Contact</p>
            <a href="mailto:elizabeth10harrington@gmail.com">Email</a>
            <a href="https://github.com/ebudhai" target="_blank" rel="noopener noreferrer">GitHub</a>
            <a href="https://www.linkedin.com/in/elizabeth-harrington-44815b252" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          </div>
        </div>

      </div>
    </footer>
  );
}
